import React, { useRef } from "react";
import Button from "./Button";
import { MAX_FILE_SIZE_IN_MB } from "../../utils/constants";
export const FilePicker = (props) => {
  const fileRef = useRef(null);
  const { onFileSelection, acceptMultiple = false, ...buttonProps } = props;
  const handleFileSelect = (e) => {
    const files = e.target.files;
    const selectedFiles = [];
    const maxSize = MAX_FILE_SIZE_IN_MB * 1024 * 1024;
    for (let file of files) {
      if (file.size <= maxSize) {
        const accessUrl = window.URL.createObjectURL(file);
        const orignalFile = file;
        const fileName = file.name;
        const extension = file.name.split(".").pop();
        selectedFiles.push({ accessUrl, orignalFile, extension, fileName });
        onFileSelection(selectedFiles);
      }
      else{
        if(typeof props.onMaxSizeExceeded === "function"){
          props.onMaxSizeExceeded();
        }
        console.warn("Max size reached for the file")
      }
    }
    fileRef.current.value = "";
  };
  return (
    <>
      <Button
        {...buttonProps}
        onClick={() => {
          fileRef.current?.click();
        }}
      />
      <input
        type="file"
        multiple={acceptMultiple}
        onChange={handleFileSelect}
        hidden
        ref={fileRef}
      />
    </>
  );
};
